import React from 'react';
import { ThemeProvider } from 'styled-components';

import getGlobalProps from '../../../../helpers/constants/global-props';

import { SizeType } from '../../Progress';
import { ProgressBarData } from '../../styles';
import { BarDatum } from '../ProgressBar';

export interface ProgressBarItemProps {
  size: SizeType;
  width: number;
  datum: BarDatum;
  'aria-label'?: string;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Graphically display proportion along a bar
 */
function ProgressBarItem(props: ProgressBarItemProps) {
  const { datum, width, size, 'aria-label': ariaLabel } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        color: datum.color,
        size,
        width,
      })}
    >
      <ProgressBarData
        title={datum.tooltip}
        {...globalProps}
        role="progressbar"
        aria-valuenow={width}
        aria-label={ariaLabel}
      />
    </ThemeProvider>
  );
}

export default ProgressBarItem;
